import { SecureLink } from '~/shared/secure_link';

export interface TabGroupItemProps {
  item: any;
  groupId: string;
  isActive: boolean;
  isSidebarOpen: boolean;
  getLabel: (key: string) => string;
  onClick: (groupId: string, item: any) => void;
  onMobileNavigate?: () => void;
}

export function TabGroupItem({
  item,
  groupId,
  isActive,
  isSidebarOpen,
  getLabel,
  onClick,
  onMobileNavigate,
}: TabGroupItemProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(groupId, item);
    // Auto-close mobile drawer when navigating
    if (onMobileNavigate) {
      onMobileNavigate();
    }
  };

  return (
    <div className="mt-2">
      <SecureLink
        to={item.route?.key}
        onClick={handleClick}
        className={`flex cursor-pointer items-center py-1 pl-10 focus:outline-none ${isActive ? 'font-semibold text-primaryDefault' : 'text-neutralDefault'} ${item.disabled ? 'pointer-events-none' : ''} ${isSidebarOpen ? '' : 'm-0 justify-center'}`}
        aria-disabled={item.disabled}
      >
        {isActive && <span className="mr-2 h-2 w-2 rounded-full bg-primaryDefault" />}
        <span className={`${!isActive ? 'pl-6' : 'pl-2'}`}>{getLabel(item.item_caption_ui)}</span>
      </SecureLink>
    </div>
  );
}
